const color = {
    25: '#F3F6FF',
    50: '#CCD9FF',
    300: '#9AB3FF',
    400: '#678DFF',
    500: '#3567FF',
    700: '#0241FF', // Main
    900: '#012EB3'
};
export default color;
